export const environment = {
    production: false,
    hmr: false,
    apiEndpoint: 'https://api.dev.viecnhamay.vn/',
    version: 'development',
};
